import Dragable from "./Dragable"
import layers from "./layer"

const $ = window.$;

const bigSmallMapBreakpoint = 768;

export default class UI {
    constructor(map) {
        this.map = map;
        this.mapRenderedSmall = false;
        this.autocompleteOptions = [];
    }

    initializeUI() {

        $('[data-toggle="tooltip"]').tooltip();

        // this.dragable = new Dragable(".dragable",$('.dragable .card-header'))
        $('.dragable').each(function (index) {
            new Dragable($(this), $('.card-header', $(this)))
        });
        $('#result-tab2').on('shown.bs.tab', function (e) {
            setTimeout(function () { this.map.updateSize() }.bind(this), 10)
        }.bind(this))

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            setTimeout(function () {
                this.map.updateSize()
            }.bind(this), 10);
        }.bind(this));

        $(".selectinfo i.fa-window-close").on("click touch", function () {
            $(".selectinfo").hide();
            layers.selectLayer.getSource().clear();
        })

        
        $(".map-box .selectinfo .card-header button.hide").on("click touch", function () {
          if ($('.map-box .card-body').is(':visible')) {
              $(".map-box .card-body").fadeOut()
              
              $(".map-box .selectinfo").attr("data-status", "folded");
          } else {
              $(".map-box .card-body").fadeIn()
              
              $(".map-box .selectinfo").attr("data-status", "open");
          }

      })
        $(".map-inner .selectinfo .card-header").on("click touch", function () {
            if ($('.map-inner .card-body').is(':visible')) {
                $(".map-inner .card-body").fadeOut()
                $(".map-inner .selectinfo").css("left", "3rem");
                $(".map-inner .selectinfo").attr("data-status", "folded");
            } else {
                $(".map-inner .card-body").fadeIn()
                $(".map-inner .selectinfo").css("left", "");
                $(".map-inner .selectinfo").attr("data-status", "open");
            }

        })

        $(window).resize(() => {
            if (window.innerWidth < bigSmallMapBreakpoint) {
                $("#togglemap").height(window.innerHeight - 190);
                this.map.updateSize();
            }
        });
        if (window.innerWidth < bigSmallMapBreakpoint) {
            $("#togglemap").height(window.innerHeight - 190);
            this.map.updateSize();
        }
        this.addAutocomplete({selector:'#administrativeUnitName',
          restpath:"administrativeunit/suggest/0/",
          transformResult: (json) => {
                return json.map(entry => {
                    var suggestEntry = {
                        text: entry.name,
                        value: entry.ags,
                        id: entry.ags
                    }
                    return suggestEntry;
                })
            },
            formatResult:(item) => {
                return {
                    value: item.id,
                    text: item.text,
                    html: [
                        $('<img>').attr('src', item.icon).css("height", 18), ' ',
                        item.text
                    ]
                };
            },
            beforeSearch:(query) => {
                const selectElem = $("#districtID");

                if (selectElem.length) {
                    const selectElemValue = selectElem.val() === "" ? "0" : selectElem.val();

                    return selectElemValue + "/" + query;
                } else {
                    return query;
                }


            }
        });
        this.createPagination()
    }

    createPagination() {
        var totalPages = $('#pagination').attr("data-jsftotalpages");
        var pageNumber = parseInt($('#pagination').attr(("data-jsfpagenumber"))) + 1;
        var pageSize = $('#pagination').attr(("data-jsfpagesize"));
        $('#pagination').pagination({
            ulClassName: 'pagination mt-2',
            classPrefix: 'page-item ',
            pageSize: pageSize,
            pageNumber: pageNumber,
            dataSource: function (done) {
                var result = [];
                for (var i = 1; i <= totalPages; i++) {
                    result.push(i);
                }
                done(result);
            },
            callback: function (data, pagination) {
                if ($("#currentPage").val() != pagination.pageNumber - 1) {
                    $("#currentPage").val(pagination.pageNumber - 1)
                    $("#currentPage").trigger("change")
                }
                return false;
            }
        });
    }

    initAutocomplete(selector, restpath, transformResult, formatResult, beforeSearch) {
        $(selector).autoComplete({
            resolver: 'custom',
            minLength: 1,
            formatResult: formatResult,
            events: {
                search: function (qry, callback) {
                    if (beforeSearch) {
                        qry = beforeSearch(qry);
                    }
                    // let's do a custom ajax call
                    fetch(contextPath + "/rest/" + restpath + qry)
                        .then(function (response) {
                            if (response.status === 200) {
                                return response.json();
                            }
                        })
                        .then(function (json) {
                            callback(transformResult(json))
                        })
                }
            }
        });
    }
    
    addAutocomplete(options) {
      this.autocompleteOptions.push(options);
    }
    initAutocompleteOptions() {
      this.autocompleteOptions.forEach(options => {
      $(options.selector).autoComplete({
        resolver: 'custom',
        minLength: 1,
        formatResult: options.formatResult,
        events: {
            search: function (qry, callback) {
                if (options.beforeSearch) {
                    qry = options.beforeSearch(qry);
                }
                // let's do a custom ajax call
                fetch(contextPath + "/rest/" + options.restpath + qry)
                    .then(function (response) {
                        if (response.status === 200) {
                            return response.json();
                        }
                    })
                    .then(function (json) {
                        callback(options.transformResult(json))
                    })
            }
        }
    })
      });
    }
    

    initAutocompleteold() {
        $('#administrativeUnitName').autoComplete({
            resolver: 'custom',
            minLength: 1,
            formatResult: function (item) {
                return {
                    value: item.id,
                    text: item.text,
                    html: [
                        $('<img>').attr('src', item.icon).css("height", 18), ' ',
                        item.text
                    ]
                };
            },
            events: {
                search: function (qry, callback) {
                    // let's do a custom ajax call
                    fetch(contextPath + "/rest/administrativeunit/suggest/" + qry)
                        .then(function (response) {
                            if (response.status === 200) {
                                return response.json();
                            }
                        })
                        .then(function (json) {
                            var result = json.map(entry => {
                                var suggestEntry = {
                                    text: entry.name,
                                    value: entry.ags,
                                    id: entry.ags
                                }
                                return suggestEntry;
                            })
                            callback(result)
                        })
                }
            }
        });
    }

}